import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TransporterModel } from 'src/app/models/archive/transporter.model';
import { TransporterService } from 'src/app/services/archive/transporter.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { UpdateDocumentTransporterComponent } from '../update-document-transporter/update-document-transporter.component';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ProviderService } from 'src/app/services/archive/provider.service';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';

@Component({
  selector: 'app-register-transporter',
  templateUrl: './register-transporter.component.html',
  styleUrls: ['./register-transporter.component.scss'],
  standalone: false
})
export class RegisterTransporterComponent implements OnInit {

  @ViewChild('changeDocumentModal') changeDocumentModalComponent?: CustomModalComponent | null = null;
  branchId: number = 0;
  componentChangeDocumentModal = UpdateDocumentTransporterComponent;
  disabledForm: boolean = false;
  formTransporter: FormGroup = new FormGroup({});
  inputsForChangeDocumentModals$ = new BehaviorSubject<any>({
    transporterContract: new TransporterModel()
  });
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listTypeDocument: any[] = [];
  listProviders: any[] = [];
  nameWindow: string = 'Captura Transportadores';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  swInvoiceTransport: boolean = false;
  stateTransporter: string = '';
  titleState: string = '';
  transporterContract: TransporterModel = new TransporterModel();
  transporterId: number = 0;
  url: string = 'transporter';

  constructor(private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private transporterService: TransporterService,
    private providerService: ProviderService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(new TransporterModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.transporterId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  changeBranch(branchId: number) {
    this.branchId = branchId;
    this.transporterContract = new TransporterModel();
    this.transporterContract.branchId = branchId;
    this.validateForm(this.transporterContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  changeDocument(document: string) {
    if (document !== '') {
      const branchId = this.formTransporter.get("branchId")?.value;
      const typeDocumentId = this.formTransporter.get("typeDocumentId")?.value;
      this.getTransporterByDocument(branchId, document, typeDocumentId);
    } else {
      this.createNewRegister();
    }
  }

  async changeStateTransporter() {
    if (!this.transporterId || this.transporterId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un transportador.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para cambiar el estado del transportador. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(
        this.transporterService.setActiveTransporter(this.transporterContract.transporterId)
      );
      this.transporterContract = response;
      this.validateForm(this.transporterContract);
      if (response.active) {
        this.toastHandlerService.showToast(
          'success',
          'El transportador fue activado exitosamente.'
        );
      } else {
        this.toastHandlerService.showToast(
          'success',
          'El transportador fue inactivado exitosamente.');
      }
    } catch (error) {
      console.error('Error al cambiar el estado del transportador.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear transportadores. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.transporterId = 0;
    this.transporterContract = new TransporterModel();
    this.transporterContract.branchId = this.branchId;
    this.validateForm(this.transporterContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar el transportador. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.transporterId || this.transporterId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un transportador.'
      );
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el transportador?')) {
      try {
        await firstValueFrom(this.transporterService.deleteTransporter(this.transporterContract.transporterId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El transportador fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el transportador.', error);
      }
    }
  }

  async getAllLists() {
    try {
      const [branches, typeDocuments, providers] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.transporterService.getAllTypeDocumentsForSelectAsync()),
        firstValueFrom(this.providerService.getAllProvidersTransportForSelect()),
      ]);
      this.listBranches = branches;
      this.listTypeDocument = typeDocuments;
      this.listProviders = providers;
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(
        this.userAuthenticatedService.branchObservable.pipe(
          filter(branch => !!branch && branch.branchId !== 0)
        )
      );
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la primera sucursal del usuario autenticado.', error);
    }
  }

  getGeneralParametersByCompany() {
    return new Promise((resolve) => {
      this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
        this.swInvoiceTransport = response.some(x => x.name === GeneralParameters.transportInvoice);
      });
      resolve(true);
    });
  }

  async getTransporterByDocument(branchId: number, document: string, typeDocumentId: number) {
    try {
      const transporter = await firstValueFrom(this.transporterService.getTransporterByDocumentAsync(branchId, document));
      if (transporter.transporterId == 0) {
        this.transporterContract.typeDocumentId = typeDocumentId;
        this.transporterContract.document = transporter.document;
        this.transporterContract.digitVerification = transporter.digitVerification;
      } else {
        this.transporterId = transporter.transporterId;
        this.transporterContract = transporter;
      }
      this.validateForm(this.transporterContract);
      this.location.replaceState(`/${this.url}/register/${this.transporterId}`);
    } catch (error) {
      console.error('Error al obtener el transportador por documento.', error);
      this.formTransporter.controls['digitVerification'].patchValue(null);
    }
  }

  async getTransporterById() {
    try {
      const response = await firstValueFrom(this.transporterService.getTransporterById(this.transporterId));
      this.transporterContract = response;
      this.validateForm(response);
    } catch (error) {
      console.error('Error al obtener el transportador por Id.', error);
    }
  }

  async getTransporterByName() {
    const branchId = this.formTransporter.get('branchId')?.value;
    const name = this.formTransporter.get('name')?.value;
    const previousName = this.transporterContract.name;
    if (name.toLowerCase() === previousName?.toLowerCase()) { return; }
    try {
      const response = await firstValueFrom(this.transporterService.getTransporterByName(branchId, name));
      if (response) {
        if (!await this.confirmDialogService.confirm(
          `El transportador con doc. ${response.document} - ${response.name} tiene el mismo nombre. ¿Desea continuar?`
        )) {
          this.formTransporter.controls['name'].patchValue(null);
        }
      }
    } catch (error) {
      console.error('Error al consultar el transportador por nombre.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getFirstBranchByUserAuthenticatedAsync(),
      this.getPermissionProfileByUrl(),
      this.getGeneralParametersByCompany(),
      this.getAllLists(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.transporterId !== null && this.transporterId !== 0) {
      await this.getTransporterById();
    } else {
      this.createNewRegister();
    }
  }

  openChangeDocumentModal() {
    if (!this.transporterId || this.transporterId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un transportador.'
      );
      return;
    }
    if (!this.transporterContract.active) {
      this.toastHandlerService.showToast(
        'warning',
        `El transportador se encuentra inactivo.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para la edición de transportadores. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.inputsForChangeDocumentModals$.next({ transporterContract: this.transporterContract });
    this.changeDocumentModalComponent && this.changeDocumentModalComponent.show();
  }

  async send() {
    this.validateFormControls();
    if (this.formTransporter.valid) {
      const modelTransporter = this.formTransporter.getRawValue() as TransporterModel;
      if (modelTransporter.alterPhone == "") modelTransporter.alterPhone = null;
      if (this.transporterId == 0) {
        try {
          const response = await firstValueFrom(this.transporterService.createTransporter(modelTransporter));
          this.transporterId = response.transporterId;
          this.transporterContract = response;
          this.validateForm(this.transporterContract);
          this.location.replaceState(`/${this.url}/register/${this.transporterId}`);
          this.toastHandlerService.showToast(
            'success',
            `El transportador fue creado exitosamente.`
          );
        } catch (error) {
          console.error('Error al crear el transportador.', error);
        }
      } else {
        this.transporterContract.branchId = modelTransporter.branchId;
        this.transporterContract.typeDocumentId = modelTransporter.typeDocumentId;
        this.transporterContract.document = modelTransporter.document;
        this.transporterContract.digitVerification = modelTransporter.digitVerification;
        this.transporterContract.name = modelTransporter.name;
        this.transporterContract.active = modelTransporter.active;
        this.transporterContract.swExternal = modelTransporter.swExternal;
        this.transporterContract.phone = modelTransporter.phone;
        this.transporterContract.alterPhone = modelTransporter.alterPhone;
        this.transporterContract.providerId = modelTransporter.providerId;
        try {
          const response = await firstValueFrom(this.transporterService.updateTransporter(this.transporterContract));
          this.transporterContract = response;
          this.validateForm(this.transporterContract);
          this.toastHandlerService.showToast(
            'success',
            `El transportador fue modificado exitosamente.`
          );
        } catch (error) {
          console.error('Error al modificar el transportador.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      typeDocumentId: {
        required: 'El campo Tipo de Documento es obligatorio.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El campo Dígito de Verificación es obligatorio.',
        min: 'El Dígito de Verificación no puede ser menor que 0.',
        max: 'El Dígito de Verificación no puede ser mayor que 9.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El Nombre no puede tener más de 75 caracteres.'
      },
      phone: {
        required: 'El campo Teléfono es obligatorio.',
        minlength: 'El Teléfono debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono no puede tener más de 15 caracteres.'
      },
      alterPhone: {
        minlength: 'El Teléfono alterno debe tener al menos 7 caracteres.',
        maxlength: 'El Teléfono alterno no puede tener más de 15 caracteres.'
      },
      active: {
        required: 'Debe indicar si el transportador está activo o inactivo.'
      },
      swExternal: {
        required: 'Debe indicar si el transportador es externo o no.'
      },
      providerId: {
        required: 'Debe seleccionar una empresa transportadora.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTransporter.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  reloadTransporter(event: any) {
    if (event.reload) {
      this.transporterContract = event.transporterModel;
      this.validateForm(this.transporterContract);
    }
  }

  updateFormState() {
    if (this.transporterContract.active) {
      this.disabledForm = false;
      this.titleState = 'inactivar';
      this.severityState = 'success';
      this.stateTransporter = 'Activo';
      setTimeout(() => this.formTransporter.enable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateTransporter = 'Inactivo';
      setTimeout(() => {
        this.formTransporter.disable(),
          this.formControlStateService.setControlState(this.formTransporter, ['branchId', 'document'], true)
      });
    }
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formTransporter.disable());
    }
    setTimeout(() => this.formTransporter.controls["digitVerification"].disable());
  }

  validateForm(transporter: TransporterModel) {
    this.formTransporter = this.formBuilder.group({
      branchId: [transporter.branchId, [Validators.required]],
      typeDocumentId: [transporter.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [transporter.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [transporter.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]],
      name: [transporter.name, [Validators.required, Validators.maxLength(75)]],
      phone: [transporter.phone, [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      alterPhone: [transporter.alterPhone, [Validators.minLength(7), Validators.maxLength(15)]],
      active: [transporter.active],
      swExternal: [transporter.swExternal],
      providerId: [transporter.providerId, this.swInvoiceTransport ? [Validators.required, Validators.min(1)] : []]
    });

    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formTransporter.controls).forEach((key) => {
      const control = this.formTransporter.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
